// Отмена своей сборки (общая очередь Word: одна сборка за раз, позиция в очереди видна в верхней строке).
import { useState } from 'react';
import { ctx } from '../../core/ctx';
import { Icon } from '../../ui/icons';
import { authApi } from './session';

export function CancelJobButton({ pid }: { pid: string | null }) {
  const [busy, setBusy] = useState(false);
  const cancel = async () => {
    if (busy) return;
    setBusy(true);
    try {
      const { jobs } = await authApi.jobs();
      const mine = jobs.filter((j) => (j.status === 'queued' || j.status === 'running') && (!pid || j.project === pid));
      for (const j of mine) await authApi.cancelJob(j.id);
      // сообщение - одно, нейтральное; о Word - только если он уже собирал этот отчёт (его Word останавливается)
      const inWord = mine.some((j) => j.status === 'running' && j.queue === 0);
      if (!mine.length) ctx.toast('Нет сборок для отмены', 'info', 4000);
      else if (inWord) ctx.toast('Сборка отменяется: Word этой сборки останавливается', 'info', 5000);
    } catch (e: any) { ctx.toast(e.message, 'error'); } finally { setBusy(false); }
  };
  return (
    <button type="button" className="au-cancel-job" onClick={cancel} disabled={busy} data-testid="job-cancel"
      data-tip="Отменить сборку" data-tip-desc="Ожидающая в очереди Word сборка отменяется сразу">
      <Icon name="close" size={13} />
    </button>
  );
}
